import { Left } from './Left'
import { Middle } from './Middle'
import { RightAdd } from './RightAdd'
import { RightEdit } from './RightEdit'
import { useApprovalModel } from "../approvalModel";
import '../approval.less'

export const Approval = () => {

    const { selectedShop } = useApprovalModel()

    return (
        <>
            <div className="container">
                <div className="child left">
                    <Left />
                </div>
                <div className="child middle">
                    <Middle />
                </div>
                <div className="child right">
                    {selectedShop && selectedShop.level == 1 && <RightAdd />}
                    {selectedShop && selectedShop.level == 2 && <RightEdit />}
                </div>
            </div >
        </>
    )
}